/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React, { useState } from 'react'; // Importing React and useState for state management
import { useTranslation } from 'react-i18next'; // Importing the translation hook
import AddTemplateModal from '../../pages/Cards/Modal/AddTemplateModal'; // Importing the modal component to add templates
import { toast } from 'react-toastify'; // Importing the toast library for notifications
import ButtonAction from "./ButtonAction"; // Importing the custom button component
import { AssignIcon } from "./IconButtons"; // Importing the icon used in the button

// Main component for adding templates to selected cards
const AddTemplate = ({
                         setSelectedCards, // Function to update selected cards
                         selectedCards, // Current state of selected cards
                         setModified, // Function to mark data as modified
                         results
                     }) => {
    const { t } = useTranslation(); // Using the translation hook
    const [addCustomizedDialogShow, setAddCustomizedDialogShow] = useState(false); // Local state to control modal visibility

    // Handler for when the action button is clicked
    const handleCard = () => {
        // Check if no cards are selected
        if (selectedCards.length === 0) {
            toast.error(t('select_a_card')); // Show error message if no card is selected
            return;
        }
        setAddCustomizedDialogShow(true); // Show modal if cards are selected
    };

    return (
        <>
            {/* Action button that triggers handleCard on click */}
            <ButtonAction
                id={"btn_at_assign_template"} // Unique ID for the button
                name={"assign_template"} // Button name
                className={"btn-icon-accent-450"} // CSS class for styling
                onClick={handleCard} // Click handler
                Icon={AssignIcon} // Icon to display in the button
                splitName={false}
                disabled={selectedCards.length === 0} // Disable button if no cards are selected
            />

            {/* Modal is shown when addCustomizedDialogShow is true */}
            {addCustomizedDialogShow &&
            <AddTemplateModal
                open={addCustomizedDialogShow} // Control modal visibility
                onHide={() => {
                    setAddCustomizedDialogShow(false); // Close the modal
                    setSelectedCards([]); // Clear selected cards after closing
                }}
                selectedCards={selectedCards} // Pass selected cards to the modal
                setModified={setModified} // Pass function to mark data as modified
                results={results}
            />
            }
        </>
    );
};

export default AddTemplate; // Exporting the component for use elsewhere in the app
